var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center mx-auto"},[(_vm.title && _vm.title.length)?_c('h4',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),_c('font-awesome-icon',{class:_vm.iconClasses,attrs:{"align":"center","icon":_vm.icon,"fixed-width":"","spin":"","size":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }